<template>
  <section class="wrapper wrapper-content animated fadeInRight">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="loadSettledCredits">
        <div class="formContainer">
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-sm-12">Data</label>
              <div class="col-sm-12">
                <input type="date" class="form-control" v-model="form.date" />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Gerar Relatório
            </button>
          </div>
        </div>
      </form>
      <div class="space-25"></div>
    </div>
    <table class="table table-hover table-mail">
      <spinner v-if="showSpinner" />
      <thead class="table-head">
        <tr>
          <th>CRIAÇÃO</th>
          <th>PAGAMENTO</th>
          <th>PLACA</th>
          <th>MONITOR</th>

          <th>VALOR</th>
        </tr>
      </thead>
      <tbody class="table-list">
        <tr v-for="(credit, key) in credits" :key="key">
          <td>{{ DateBR(credit.createdAt) }}</td>
          <td>{{ DateBR(credit.paymentDate) }}</td>
          <td>{{ credit.vehicle.licencePlate.toUpperCase() }}</td>
          <td>
            {{ credit.settledEmployee
                ? credit.settledEmployee.fullName
                : 'Carteira' }}
          </td>
          <td>{{ totalToCurrencyBR(credit.settledAmountPaid) }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script>
import Spinner from '@/components/Spinner';
import { toast } from '@/plugins/toast';
export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      form: {
        date: '',
      },
      credits: [],
    };
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
    async loadSettledCredits() {
      try {
        this.showSpinner = true;
        const payload = {
          ...this.form,
        };

        const credits = await this.$store.dispatch(
          'REPORTS/SettledCredits',
          payload,
        );
        this.credits = credits;
      } catch (error) {
        toast.error('Falha ao carregar relatório.');
      } finally {
        this.showSpinner = false;
      }
    },
  },
};
</script>